$(window).on('load', function(){
	// Prevent transitions before DOM ready
	$("body").removeClass("preload");
	$('#cdm-loader').remove();

	script_on_load('to-animate', function(){
		checkAnimations();
	});

	if($('#banner .slider .slide').length > 1){
		$('#banner .slider').addClass('owl-carousel');

		script_on_load('js-owl-carousel', function(){
			// Slider exemple - https://owlcarousel2.github.io/OwlCarousel2/
	
			$('#banner .slider').owlCarousel({
				items: 1,
				loop: true,
				autoplay: true,
				autoplayTimeout: 10000,
				smartSpeed: 500
			});
		});
	}

	if($('.vehicles-slider').length){
		script_on_load('js-owl-carousel', function(){
			// Slider exemple - https://owlcarousel2.github.io/OwlCarousel2/
	
			var vehiclesSlider = $('.vehicles-slider .owl-carousel');

			vehiclesSlider.owlCarousel({
				items: 5,
				loop: true,
				smartSpeed: 500,
				nav: true,
				navText: [phpData.carousel_nav, phpData.carousel_nav],
				dots: false,
				center: false,
				responsive: {
					0 : {
						items: 1
					},
					500 : {
						items: 3
					},
					767 : {
						items: 5
					}
				}
			});

			// Si le style principale est loadé après le carousel, on le refresh pour les styles.
			$('#main-style-css').on('load', function(){
				vehiclesSlider.trigger('refresh.owl.carousel');
			});
		});
	}
});	

// Menumobile - http://mmenu.frebsite.nl/
script_on_load('mmenu', function(){
	$('#mmenu').mmenu({
		"slidingSubmenus": false,
		"extensions": [
			"pagedim-black"
		],
		navbar: {
			title: null
		},
		"offCanvas": {
			"pageSelector": "#page",
			"zposition": 'front',
			"position": 'right'
		},
		"navbars": [			
			{
				"position": "top",
				"content": [
					$('.home-link-mmenu'),
					"close"
				]
			},
			{
				"position": "bottom",
				"content": [
					$('.quick-navigation ul').clone().addClass('quick-navigation')
				]
			},
		]
	});

	$('#mmenu .mm-subopen + a').click(function(e){
		e.preventDefault();
		$(this).prev().trigger('click');
	});
	$('#mmenu .search-field').attr('placeholder', '').focusout(function(){
		if($(this).val() !== ''){
			$(this).closest('form').submit();
		}
	});
});
	
// Add class desktop si non mobile.
$(window).on('load resize',function() {
	script_on_load('theme-utils', function(){
		if(!isMobile()){
			$('body').addClass('desktop');
		}else{
			$('body').removeClass('desktop');
		}
	});
}); 

$(function(){
	$('select').each(function(){
		let selectWrap = $('<span class="select-wrap"><span class="select-span"></span></span>');
		$(this).before(selectWrap);
		$(this).prependTo(selectWrap);
	});

	$('a[href="#popup-soumission"]').click(function(e){
		e.preventDefault();

		open_popup('#popup-soumission');
	});

	$('a[href="#popup-essai"]').click(function(e){
		e.preventDefault();

		open_popup('#popup-essai');
	});

	$('#page-blocker, .popup .close').click(function(){
		close_popup();
	});

	/* inscription a l'infolettre */
	$('.infolettre, .newsletter-form').submit(function(e){
		e.preventDefault();

		var messageLog = $(this).find('.error-log');

		if(!validateEmail($(this).find('input[name="email"]').val())){
			messageLog.text(traduction.emailError).removeClass('success').addClass('error').show();
			
		}else{
			// update user interface
			messageLog.html(traduction.emailProcessing).removeClass('success error').show();

			var data = {
				ajax: true,
				email: $(this).find('input[name="email"]').val(),
				lang: phpData.lang,
				action: 'newsletter_subscription'
			}
			
			// Prepare query string and send AJAX request
			$.post( phpData.ajax_url, data, function(res){
				JSON.stringify(res);

				if(res.success){				
					messageLog.removeClass('error').addClass('success').html(res.message);
					
				}else{
					messageLog.removeClass('success').addClass('error').html(res.message);
				}
			}, 'json');
			
			return false;
		}
	});

	if($('section.choix_de_couleurs').length){
		$('section.choix_de_couleurs').each(function(){
			var colorSection = $(this);

			colorSection.find('.color-vehicle').each(function(){
				var colorVehicle = $(this);
				var color = $('<span class="color" style="background-color: '+$(this).data('color')+';"></span>');
				colorSection.find('.color-listing').append(color);

				color.on('click', function(){
					$(this).siblings('.color').removeClass('current');
					$(this).addClass('current');

					colorSection.find('.color-vehicle').removeClass('current');
					colorVehicle.addClass('current');

					colorSection.find('.color-name').text(colorVehicle.data('title'));
				});
			});

			colorSection.find('.color-listing .color:first-child').click();
		});
	}

	script_on_load('google-map', function(){
		const geocoder = new google.maps.Geocoder();
		var delay;
		var last_value = '';

		$('input.find-dealer').val('');
		$('input.find-dealer').on('change keyup', function(){
			var input = $(this);
			if(input.val() == last_value){
				return false;
			}
	
			last_value = input.val();
	
			clearTimeout(delay);
	
			delay = setTimeout(() => {
				postalLatLng(last_value, function(latlng){
					var dealersPosition = [];
					var allDealers = []; // tableau avec des clé incrémentiels pour plus tard.
					var postalLatLng = new google.maps.LatLng({lat: latlng.lat, lng: latlng.lng});


					$.each(phpData.dealers, function(index, val){
						dealersPosition.push(new google.maps.LatLng(val.map.lat, val.map.lng));
						allDealers.push(val);
					});

					// Google distance matrix limite la quantité d'origins et de destinations à 25 chaque.
					var totalRequest = Math.ceil(dealersPosition.length / 25);
					var requestsCount = 0;
					var failedRequestsCount = 0;
					var service = new google.maps.DistanceMatrixService();
					var dist = [];
	
					for(var i = 0; i < totalRequest; i++){
						let dealersRequest = dealersPosition.splice(0, 25); // On get les 25 premiers
	
						// On wrap le tous dans une function avec un callback pour garder la valeur de i dans le callback.
						(function(requestNum){
							service.getDistanceMatrix({
								origins: [postalLatLng],
								destinations: dealersRequest,
								travelMode: 'DRIVING',
								unitSystem: google.maps.UnitSystem.METRIC,
								avoidHighways: false,
								avoidTolls: false,
							}, getResults);
			
							function getResults(response, status){
								var realMarkerIndex = requestNum * 25; // Pour retrouver le bon index du marker, on utilise le numéro de la requête, car la première requête commence toujours à 0 (0-24) 0*25 = 0 la deuxième à 25 (25-49) 1*25 = 25
	
								if(status == 'OK'){
									var origins = response.originAddresses;
									//var destinations = response.destinationAddresses;
								
									for(var i = 0; i < origins.length; i++){
										var results = response.rows[i].elements;
			
										for(var j = 0; j < results.length; j++){
											var element = results[j];
											var distance = element.distance.value;
											// var duration = element.duration.text; Temps pour se rendre.
											
											dist.push({
												name: allDealers[realMarkerIndex].name,
												address: allDealers[realMarkerIndex].map.address,
												phone: allDealers[realMarkerIndex].phone,
												email: allDealers[realMarkerIndex].email,
												roadtest_email: allDealers[realMarkerIndex].roadtest_email,
												dist: distance
											});
											
											realMarkerIndex++;
										}
									}
			
								}else{
									failedRequestsCount++;
								}
	
								requestsCount++;
	
								if(totalRequest == requestsCount){
									updateMap(failedRequestsCount);
								}
							}
						})(i);
					}
	
					function updateMap(failedCount){
						if(failedCount == totalRequest){ // Si les requêtes pour la distance par la route ont échoués, on calcule par vol d'oiseau.
							$.each(phpData.dealers, function(index, val){
								var markerPos = new google.maps.LatLng(val.map.lat, val.map.lng);
			
								dist.push({
									name: val.name,
									address: val.map.address,
									phone: val.phone,
									email: val.email,
									roadtest_email: val.roadtest_email,
									dist: google.maps.geometry.spherical.computeDistanceBetween(postalLatLng, markerPos),
								});
							});
						}

						dist.sort(compare);
	
						var dealerHTML = '';
						dealerHTML += '<div>';
						dealerHTML += 	'<input type="radio" name="closest_dealer" value="" id="">';
						dealerHTML += 	'<label class="closest-dealer" for="">';
						dealerHTML += 		'<span class="custom-checkbox"></span>';
						dealerHTML += 		'<div>';
						dealerHTML += 			'<span class="dealer-name"></span>';
						dealerHTML += 			'<span class="dealer-address"></span>';
						dealerHTML += 			'<span class="dealer-phone"></span>';
						dealerHTML += 		'</div>';
						dealerHTML += 		'<span class="dealer-dist"></span>';
						dealerHTML += 	'</label>';
						dealerHTML += '</div>';
		
						var newContent = $('<div class="closest_dealer_list"></div>');
						for(let i = 0; i < 3; i++){
							let dealerContent = $(dealerHTML).clone();
							let email = dist[i].email;
							
							if(input.parents('#popup-essai').length && dist[i].roadtest_email != ""){
								email = dist[i].roadtest_email;
							}

							dealerContent.find('input[name="closest_dealer"]').attr('id', 'dealer-radio-'+i).attr('value', email);

							dealerContent.find('.closest-dealer').attr('for', 'dealer-radio-'+i);
		
							dealerContent.find('.dealer-name').text(dist[i].name);
							dealerContent.find('.dealer-address').text(dist[i].address);
							dealerContent.find('.dealer-phone').text(dist[i].phone);
							dealerContent.find('.dealer-dist').text((dist[i].dist/1000).toFixed(1) + " km");
		
							newContent.append(dealerContent);
						}
		
						// Checked la première valeur par défaut
						$(newContent.find('input[name="closest_dealer"]')[0]).prop('checked', true);
		
						input.parents('form').find('input[type="hidden"][name="closest_dealer"]').remove();
						input.siblings('.closest_dealer_list').remove();
						input.after(newContent);
					}
				});
			}, 1000);
		});
	
		// Empêche de submit si les concessionnaires ne sont pas affiché
		$(window).keydown(function(event){
			if( (event.keyCode == 13) &&
				event.target.nodeName != 'TEXTAREA' &&
				$(event.target).parents('form').find('.find-dealer').length &&
				!$('input[name="closest_dealer"]:checked').val()){
			  
					event.preventDefault();
					  return false;
			}
		});
		
		// retourne la lat lng d'un code postal
		postalLatLng = function(codePostal, callback){
			geocoder.geocode( { 'address': codePostal, 'region': 'qc'}, function(results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					var latitude = results[0].geometry.location.lat();
					var longitude = results[0].geometry.location.lng();
	
					callback({lat: latitude, lng: longitude});
				}
				return false;
			});
		};
	
		// ordonne un array par distance
		function compare(a,b) {
			if (a.dist < b.dist)
				return -1;
			if (a.dist > b.dist)
				return 1;
			return 0;
		}
	});

	if($('.versions_du_vehicule').length){
		$('.toggle-desc').on('click', function(){
			$(this).toggleClass('toggled');
			$(this).siblings('.version-desc').toggle(300);
		});
	}


	if($('#legal').length){
		$('.toggle-legal').addClass('toggled');
		$('.legal-text').hide();

		$('.toggle-legal').on('click', function(){
			$(this).toggleClass('toggled');
			$(this).siblings('.legal-text').toggle(300);
		});
	}
});

function open_popup(popupID){
	$('#mmenu').data('mmenu').close();
	$('.popup').removeClass('open');
	$(popupID).addClass('open');
}

function close_popup(){
	$('.popup').removeClass('open');
}